(function () {
  "use strict";

  function addToCart(variantId, sellingPlanId, button) {
    const body = { id: String(variantId), quantity: 1 };
    if (sellingPlanId) body.selling_plan = String(sellingPlanId);

    if (button) {
      button.disabled = true;
      button.classList.add("loading");
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Add to cart failed");

        // The theme refreshes the drawer off this event via its own section GET, so
        // give it a moment before opening — same 400ms compare.js uses.
        document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
        setTimeout(function () {
          const cartIcon = document.querySelector("[data-js-cart-icon]");
          if (cartIcon) cartIcon.click();
          if (button) {
            button.disabled = false;
            button.classList.remove("loading");
          }
        }, 400);
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.classList.remove("loading");
        }
      });
  }

  // Take over add to cart, but only where the buy box is actually present. Capture
  // phase with stopImmediatePropagation so the theme's own handler does not also
  // submit the form and add a second line from the hidden variant picker. Products
  // without the buy box (sold out, or not configured) fall through untouched.
  document.addEventListener(
    "click",
    function (event) {
      const button =
        event.target.closest && event.target.closest(".product-form__cart-submit");
      if (!button || button.disabled) return;

      const container = button.closest(".product, .quick-product");
      if (!container || !container.querySelector(".supply-selector")) return;

      const radio = container.querySelector('input[name="order-type"]:checked');
      if (!radio) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addToCart(radio.dataset.variantId, radio.dataset.sellingPlanId, button);
    },
    true
  );

  function initBuyBox(form) {
    if (!form || form.dataset.buyBoxWired === "true") return;
    form.dataset.buyBoxWired = "true";

    const container = form.closest(".product, .quick-product");
    if (!container) return;

    // Clicks the theme's variant selector to update the gallery image and ?variant= URL.
    // Display only — add to cart reads the checked radio, not this.
    function selectVariantOption(optionHandle) {
      const optionButton = container.querySelector(
        `.product__controls-group [data-option-handle='${optionHandle}']`
      );
      if (optionButton) optionButton.click();
    }

    form.querySelectorAll('input[name="order-type"]').forEach(function (radio) {
      radio.addEventListener("change", function () {
        selectVariantOption(this.value);
      });
    });

    form.querySelectorAll("[data-one-time-variant]").forEach(function (onetimeVariantSelect) {
      onetimeVariantSelect.addEventListener("change", function () {
        const selectedVariant = this.options[this.selectedIndex];
        const onetimeInput = form.querySelector("[data-one-time-input]");
        if (!selectedVariant || !onetimeInput) return;

        onetimeInput.value = this.value;
        onetimeInput.dataset.variantId = selectedVariant.dataset.variantId;

        const onetimeCard = onetimeInput.closest(".supply-option");
        const selectedVariantPrice = onetimeCard.querySelector(".supply-option__price");
        const selectedVariantPricePerCount = onetimeCard.querySelector(".supply-option__price-per-count");
        const listPrice = onetimeCard.querySelector(".supply-option__list-price");
        selectedVariantPrice.textContent = selectedVariant.dataset.otpPrice;
        selectedVariantPricePerCount.textContent = selectedVariant.dataset.otpPricePerCount;
        // Empty when the variant has no one-time discount; CSS hides it via :empty.
        if (listPrice) listPrice.textContent = selectedVariant.dataset.otpListPrice || "";
        onetimeInput.checked = true;
        selectVariantOption(this.value);
      });
    });

    // Deep link. ?otp=true picks the one-time card, since a variant id alone doesn't say
    // which card is wanted. Runs after the listeners above because it drives the
    // dropdown and lets its change handler update the card.
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get("variant");
    if (variantParam) {
      const isOneTime = params.get("otp") === "true";
      const variantCardSelector = `input[name="order-type"][data-variant-id="${variantParam}"]`;

      if (isOneTime) {
        const onetimeVariantSelect = form.querySelector("[data-one-time-variant]");
        const selectedVariant =
          onetimeVariantSelect &&
          onetimeVariantSelect.querySelector(`option[data-variant-id="${variantParam}"]`);

        if (selectedVariant) {
          onetimeVariantSelect.value = selectedVariant.value;
          onetimeVariantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          const variantCard = form.querySelector(`${variantCardSelector}[data-one-time-input]`);
          if (variantCard) variantCard.checked = true;
        }
      } else {
        const variantCard = form.querySelector(`${variantCardSelector}:not([data-one-time-input])`);
        if (variantCard) variantCard.checked = true;
      }
    }

    // The theme's picker starts on the first variant, but the checked card can be a
    // different one (buy_box_default_variant, or a deep link). Nothing fires a change
    // event on load, so drive it here — otherwise the gallery shows an image that
    // contradicts the selected card.
    //
    // The theme's own [name="id"] says whether it already agrees: it only changes once
    // the theme's option-change handler has run. That makes this a no-op when the two
    // already match, and it is also why the second, late call exists — a click landing
    // before that handler is wired only marks the chip, without switching the media or
    // the URL.
    function syncInitialVariant() {
      const checked = form.querySelector('input[name="order-type"]:checked');
      const idField = container.querySelector('form[action*="/cart/add"] [name="id"]');
      if (!checked || !idField) return;
      if (idField.value === checked.dataset.variantId) return;

      selectVariantOption(checked.value);
    }

    function scheduleInitialSync() {
      syncInitialVariant();
      setTimeout(syncInitialVariant, 1200);
    }

    if (document.readyState === "complete") {
      scheduleInitialSync();
    } else {
      window.addEventListener("load", scheduleInitialSync, { once: true });
    }
  }

  function initBuyBoxes() {
    document.querySelectorAll(".supply-selector").forEach(function (form) {
      initBuyBox(form);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBuyBoxes);
  } else {
    initBuyBoxes();
  }

  // Quick view renders a second copy of the buy box after page load.
  document.addEventListener("quickview:loaded", function () {
    setTimeout(initBuyBoxes, 200);
  });
})();
